<script>
import * as LucideIcons from 'lucide-vue-next'

export default {
  name: 'LegacyCustomButton',
  props: {
    text: { type: String, default: '' },
    icon: { type: String, default: '' },
    type: { type: String, default: 'button' }, // 'navigate' | 'submit' | 'button' | etc.
    small: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  emits: ['click'],
  computed: {
    iconComponent() {
      return this.icon ? LucideIcons[this.icon] : null
    },
    sizeClass() {
      return this.small ? 'h-8 px-3 text-xs' : 'h-9 px-4 text-sm'
    },
    nativeType() {
      return this.type === 'submit' ? 'submit' : 'button'
    },
  },
}
</script>

<template>
  <button
    :type="nativeType"
    :disabled="disabled"
    :class="[
      'inline-flex items-center justify-center gap-2 rounded-md font-medium shadow-sm transition-colors',
      'bg-primary text-primary-foreground hover:bg-primary/90',
      'disabled:opacity-50 disabled:pointer-events-none',
      sizeClass,
    ]"
    @click="$emit('click', $event)"
  >
    <component v-if="iconComponent" :is="iconComponent" class="w-4 h-4" />
    <span v-if="text">{{ text }}</span>
    <slot />
  </button>
</template>
